/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import arrow from "designs/images/streaming/arrow_down.png";

import type { ProductData } from "@spwn/types/firebase/firestore";
import type { FC } from "react";

export const SelectVariationSelectBox: FC<{
  variationList: ProductData[];
  onChange: (productId: string) => void;
}> = ({ variationList, onChange }) => {
  return (
    <select
      css={css`
        width: 100%;
        padding: 8px 32px 8px 16px;
        font-size: 14px;
        font-weight: normal;
        background-color: #f4f4f4;
        background-image: url(${arrow});
        background-size: 8px auto;
        background-repeat: no-repeat;
        background-position-x: right 16px;
        background-position-y: center;
        border: 1px solid #dedede;
        border-radius: 5px;
        appearance: none;
        cursor: pointer;
      `}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value={""}>選択してください</option>
      {variationList.map((variation) => (
        <option key={variation._id} value={variation._id}>
          {variation.subClassName}
        </option>
      ))}
    </select>
  );
};
